import { memo } from "react";
import { JitsiMeeting } from "@jitsi/react-sdk";

const JITSI_DOMAIN = "room.xller.com";

// Jitsi embed that only re-renders when the room or name changes, so parent refreshes
// (e.g. polling the participant list) never reload an ongoing call.
function MeetingFrame({ roomName, displayName, height = 560, isHost = false }) {
    return (
        <JitsiMeeting
            domain={JITSI_DOMAIN}
            roomName={roomName}
            configOverwrite={{
                prejoinConfig: { enabled: !isHost },
                startWithAudioMuted: !isHost,
                startWithVideoMuted: false,
                enableEmailInStats: false,
            }}
            userInfo={{ displayName: displayName || "" }}
            getIFrameRef={(iframeRef) => { iframeRef.style.height = `${height}px`; iframeRef.style.width = "100%"; iframeRef.style.border = "0"; }}
        />
    );
}

export default memo(MeetingFrame);
